import { reportError } from '@/utils/error-reporting'
import { ValidationFailedError } from '@/utils/postJson'
import { router } from '@inertiajs/vue3'
import axios from 'axios'
import { useToast } from 'primevue/usetoast'
import { useI18n } from 'vue-i18n'

const statusesWithOwnToast = new Set([403, 404, 500])

export function useSaveFailureToast(): (error: unknown) => void {
  const { t } = useI18n({ useScope: 'global' })
  const toast = useToast()

  const showError = (summary: string, detail: string): void => {
    toast.add({ severity: 'error', summary, detail, life: 5000 })
  }

  return (error: unknown): void => {
    if (error instanceof ValidationFailedError) {
      Object.values(error.errors)
        .flat()
        .forEach((message) => showError(t('toasts.save-failed.summary'), message))

      return
    }

    reportError('Saving a field failed', error)

    const status = axios.isAxiosError(error) ? error.response?.status : undefined

    if (status === 401) {
      router.reload()

      return
    }

    if (status !== undefined && statusesWithOwnToast.has(status)) {
      showError(t(`toasts.error.${status}.summary`), t(`toasts.error.${status}.detail`))

      return
    }

    showError(t('toasts.save-failed.summary'), t('toasts.save-failed.detail'))
  }
}
